import { ChatProvider, ChatWindow } from '@/features/chat';

const apiBaseUrl = (import.meta.env.VITE_API_URL ?? '').trim().replace(/\/+$/, '');

export function HomeApp() {
  return (
    <ChatProvider config={{ apiBaseUrl }}>
      <ChatWindow mode="fullscreen" />
    </ChatProvider>
  );
}
